import styled, { useTheme } from "styled-components";
import { ProjectsListWrapper } from "./ProjectsListWrapper";
import { ProjectsListRow } from "./ProjectsListRow";

export const ProjectsList = ({projects}) => {

    const GlobalTheme = useTheme();

    return (
        <StyledProjectList>
            <ProjectsListWrapper
                id="projects-kanban-active"
                title="Aktive prosjekter"
                counter={projects.filter(prj => prj && prj.projectStatus === "Active").length}
                color={GlobalTheme.colors.neutralSecondaryForeground}
            >
                {projects.map(prj => prj && prj.projectStatus === "Active" ? <ProjectsListRow key={prj.projectUuid} project={prj}/> : null)}
            </ProjectsListWrapper>

            <ProjectsListWrapper
                id="projects-kanban-inactive"
                title="Aktive prosjekter"
                counter={projects.filter(prj => prj && prj.projectStatus === "Inactive").length}
                color={GlobalTheme.colors.warningForeground}
            >
                {projects.map(prj => prj && prj.projectStatus === "Inactive" ? <ProjectsListRow key={prj.projectUuid} project={prj}/> : null)}
            </ProjectsListWrapper>

            <ProjectsListWrapper
                id="projects-kanban-finished"
                title="Aktive prosjekter"
                counter={projects.filter(prj => prj && prj.projectStatus === "Finished").length}
                color={GlobalTheme.colors.successForeground}
            >
                {projects.map(prj => prj && prj.projectStatus === "Finished" ? <ProjectsListRow key={prj.projectUuid} project={prj}/> : null)}
            </ProjectsListWrapper>

        </StyledProjectList>
    )
}

const StyledProjectList = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.md};
    height: 100%;
    filter: drop-shadow(0 2px 2px rgba(${({theme}) => theme.colors.neutralSecondaryForegroundRGB}, 0.15));
`